import instance from "@/services/api";

export const packageListApi = {
  async getMaterialSets(params) {
    return await instance()
      .get("/preset/preset_material/material_set/read/", { params })
      .then((res) => res?.data);
  },
  async updMaterialSets(body) {
    return await instance()
      .post("/preset/preset_material/material_set/upd/", body)
      .then((res) => res?.data);
  },
  async deleteMaterial(body) {
    return await instance()
      .delete("/preset/preset_material/material_set/material/delete/", {
        data: body,
      })
      .then((res) => res?.data);
  },
};
